import { render, staticRenderFns } from "./Norms.vue?vue&type=template&id=150a7502&scoped=true&"
import script from "./Norms.vue?vue&type=script&lang=js&"
export * from "./Norms.vue?vue&type=script&lang=js&"
import style0 from "./Norms.vue?vue&type=style&index=0&id=150a7502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a7502",
  null
  
)

export default component.exports